// src/hooks/useInactivity.js
// Déconnecte automatiquement après 10 min d'inactivité
import { useEffect, useCallback, useRef } from 'react'
import { useAuth } from '../context/AuthContext'

const TIMEOUT_MS = 10 * 60 * 1000 // 10 minutes

export default function useInactivity() {
  const { logout, user } = useAuth()
  const timerRef = useRef(null)

  const resetTimer = useCallback(() => {
    if (!user) return
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      logout()
      window.location.href = '/login?reason=inactivite'
    }, TIMEOUT_MS)
  }, [user, logout])

  useEffect(() => {
    if (!user) return

    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click']
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }))
    resetTimer() // Démarrer le timer au montage

    return () => {
      clearTimeout(timerRef.current)
      events.forEach(e => window.removeEventListener(e, resetTimer))
    }
  }, [user, resetTimer])
}
